export default __webpack_public_path__ + "static/media/pic1.c187f54f.jpg";